/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Group_WeekInputs */

const vi_warehouse_sales_group_week = /** @type {(inputs: Warehouse_Sales_Group_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuần`)
};

/**

* @param {Warehouse_Sales_Group_WeekInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_group_week = /** @type {((inputs?: Warehouse_Sales_Group_WeekInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Group_WeekInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_group_week(inputs)
});